export default __webpack_public_path__ + "static/media/height.87215df5.svg";